/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Trust_Window_Scope_HostnameInputs */



/**
* | output |
* | --- |
* | "single host" |
*
* @param {Audit_Details_Trust_Window_Scope_HostnameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_trust_window_scope_hostname = /** @type {((inputs?: Audit_Details_Trust_Window_Scope_HostnameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Trust_Window_Scope_HostnameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("einzelner Host")
	return /** @type {LocalizedString} */ ("single host")
});